import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

// Imports de Material
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

// Imports del Cliente API
import { MatchSearchResultDTO } from '@solverml/api';

@Component({
  selector: 'app-statistics-match-card',
  templateUrl: './statistics-match-card.component.html',
  styleUrls: ['./statistics-match-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterLink,
    DatePipe,
    MatCardModule,
    MatIconModule
  ]
})
export class StatisticsMatchCardComponent {

  // Recibe el partido del componente padre (search-tab-match)
  @Input({ required: true }) match: MatchSearchResultDTO;

}
